import React from 'react';

interface GalleryItem {
    id: string;
    image: string;
    title: string;
    artist?: string;
    collection?: string;
    link?: string;
}

interface GalleryMasonryProps {
    items: GalleryItem[];
    columns?: 2 | 3 | 4;
    className?: string;
}

export const GalleryMasonry: React.FC<GalleryMasonryProps> = ({
    items,
    columns = 4,
    className = '',
}) => {
    return (
        <div
            className={`curator-gallery ${className}`}
            style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
        >
            {items.map((item) => (
                <a
                    key={item.id}
                    href={item.link || '#'}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="curator-gallery-item"
                >
                    <img src={item.image} alt={item.title} loading="lazy" />
                    <div className="curator-gallery-overlay">
                        <div className="curator-gallery-title">{item.title}</div>
                        {item.artist && (
                            <div className="curator-gallery-artist">by {item.artist}</div>
                        )}
                    </div>
                </a>
            ))}
        </div>
    );
};

export default GalleryMasonry;
